import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
}
const PayPointsExpiration = ({
  width = 51,
  height = 50,
  color = '#006DFF',
}: IProps) => (
  <Svg width={width} height={height} viewBox="0 0 50 50" fill="none">
    <Rect
      width={width}
      height={height}
      rx={8}
      fill={color}
      fillOpacity={0.15}
    />
    <G clipPath="url(#clip0_3340_4961)">
      <Path
        d="M15.875 10a.878.878 0 00-.875.875c0 .481.394.875.875.875h6.64L8.256 26.007a.878.878 0 000 1.236.878.878 0 001.236 0L23.75 12.986v6.639c0 .481.394.875.875.875a.878.878 0 00.875-.875v-8.75a.878.878 0 00-.875-.875h-8.75zm21 3.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm-7 3.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM29 28.375a.875.875 0 111.75 0 .875.875 0 01-1.75 0zm3.5 0a2.625 2.625 0 10-5.25 0 2.625 2.625 0 005.25 0zM29.875 34.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zm7-3.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM22 28.375a.875.875 0 111.75 0 .875.875 0 01-1.75 0zm3.5 0a2.625 2.625 0 10-5.25 0 2.625 2.625 0 005.25 0zM22.875 34.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM15 35.375a.875.875 0 111.75 0 .875.875 0 01-1.75 0zm3.5 0a2.625 2.625 0 10-5.25 0 2.625 2.625 0 005.25 0zM36.875 27.5a.875.875 0 110 1.75.875.875 0 010-1.75zm0 3.5a2.625 2.625 0 100-5.25 2.625 2.625 0 000 5.25zM36 21.375a.875.875 0 111.75 0 .875.875 0 01-1.75 0zm3.5 0a2.625 2.625 0 10-5.25 0 2.625 2.625 0 005.25 0z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_3340_4961">
        <Path fill="#fff" transform="translate(8 10)" d="M0 0H31.5V28H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default PayPointsExpiration;
